import React, { useEffect, useState } from "react";
import { cn } from "../lib/cn";

const DEV_MODE_KEY = "flowstate:console:devMode";

interface DevModeToggleProps {
  onToggle?: (enabled: boolean) => void;
}

export function useDevMode(): [boolean, () => void] {
  const [enabled, setEnabled] = useState<boolean>(() => {
    try {
      return localStorage.getItem(DEV_MODE_KEY) === "true";
    } catch {
      return false;
    }
  });

  const toggle = () => {
    setEnabled((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(DEV_MODE_KEY, String(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  };

  return [enabled, toggle];
}

export function DevModeToggle({ onToggle }: DevModeToggleProps) {
  const [enabled, toggle] = useDevMode();

  const handleToggle = () => {
    toggle();
    onToggle?.(!enabled);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={cn(
        "inline-flex items-center gap-1 rounded px-2 py-0.5 text-[10px] font-mono transition-colors",
        enabled
          ? "bg-amber-500/20 text-amber-400 ring-1 ring-amber-500/40"
          : "bg-muted text-muted-foreground hover:text-foreground",
      )}
      aria-pressed={enabled}
      title="Toggle dev mode (shows raw JSON)"
    >
      DEV
    </button>
  );
}
